import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type ProductsAttributesByOwnerFlatTeamSettingGroupId =
  "products_attributes_by_owner.attribute_definitions_by_owner";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  product: "fulfillment",
};

const groupRisk: SettingRisk = {
  level: "low",
  reason:
    "Product-level settings including hazmat and product attribute definitions.",
};

export const ProductsAttributesByOwnerFlatTeamSettingGroups = [
  {
    id: "products_attributes_by_owner.attribute_definitions_by_owner",
    title: "Attribute definitions by owner",
    description:
      "Attribute definitions by owner settings on the Products attributes by owner page.",
    productArea: "general",
    access: directMerchantAccess(SettingsPermissions.SET_GENERAL_SETTINGS),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    // The by-owner route needs a concrete owner type, so the group lands on
    // the attributes list where the merchant picks one.
    fullPageTarget: { type: "settings", path: "attributes" },
    synonyms: [
      "attribute definitions by owner",
      "products attributes by owner",
    ],
  },
] as const satisfies readonly SettingGroupDefinition<ProductsAttributesByOwnerFlatTeamSettingGroupId>[];
